import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Card, Button, Container } from '@mui/material';
import { useMediaQueries } from '../../usecontext/UseProvider';
import { FaInstagram, FaPlay } from 'react-icons/fa';
import { getFollowUsMedia } from '../../services/FollowUsMedia';

const FollowOnInstagram = () => {
    const { isSmallScreen, isMediumScreen, isLargeScreen } = useMediaQueries();
    const [followUsMediaData, setFollowUsMediaData] = useState([]);
    const { contactUSData } = useMediaQueries();

    const getFollowUsMediaData = async () => {
        try {
            const response = await getFollowUsMedia();
            setFollowUsMediaData(response?.followUsMediaData);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getFollowUsMediaData();
    }, []);

    return (
        <Container
            sx={{
                pt: { lg: 5, xs: 3 },
                pb: { lg: 6, xs: 3 },
                textAlign: 'center',
            }}
        >
            <Typography
                data-aos="fade-up"
                variant={isSmallScreen ? 'h6' : isMediumScreen ? 'h5' : 'h4'}
                sx={{ fontWeight: 700 }}
                gutterBottom
            >
                Follow Us On Instagram
            </Typography>
            <Button
                data-aos="fade-up"
                data-aos-delay="400"
                variant="varient"
                size={isSmallScreen ? 'small' : 'medium'}
                startIcon={<FaInstagram />}
                sx={{
                    borderColor: '#fff',
                    backgroundColor: '#01A0E2',
                    color: '#fff',
                    borderRadius: '0',
                    mb: { lg: 6, xs: 3 },
                    fontSize: { lg: '20px' }
                }}
                onClick={() => window.open(`${contactUSData?.instagramLink}`)}
            >
                Follow on instagram
            </Button>
            <Grid container spacing={isLargeScreen ? 2 : 3}>
                {followUsMediaData?.map((video, index) => (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        key={index}
                        data-aos="zoom-in"
                        data-aos-delay={index * 200}
                        mb={isLargeScreen ? 0 : (index % 2 === 0 ? 4 : 0)}
                        mt={isLargeScreen ? 0 : (index % 2 === 0 ? 0 : 4)}
                    >
                        <Card
                            sx={{
                                borderRadius: '20px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                position: 'relative',
                                boxShadow: 'none'
                            }}
                        >
                            <Box
                                component="img"
                                src={video?.thumbnail_media?.url}
                                alt="Descriptive Alt Text"
                                sx={{
                                    borderRadius: '20px',
                                    height: '330px',
                                    maxWidth: { lg: '300px', xs: '100%' },
                                    objectFit: 'cover',
                                }}
                            />
                            <Box
                                onClick={() => window.open(`${video?.thumbnail_media_url}`)}
                                sx={{
                                    position: 'absolute',
                                    left: '50%',
                                    top: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    textAlign: 'center',
                                    color: '#fff',
                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                    borderRadius: '50%',
                                    width: '60px',
                                    height: '60px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                }}
                            >
                                <FaPlay style={{ height: '20px', width: '20px' }} />
                            </Box>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    left: '75px',
                                    bottom: '0',
                                    transform: 'translate(-50%, -50%)',
                                    color: '#fff',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '5px'
                                    }}
                                >
                                    <Typography variant='body2'>{video.title}</Typography>
                                </div>
                            </Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container >
    );
};

export default FollowOnInstagram;